import AdAccountPostbackControl from "./AdAccountPostbackControl";

const GOOGLE_CONVERSION_ACTION_NAME = "Tracify Conversions";
const GOOGLE_ADS_CONVERSIONS_URL = "https://ads.google.com/aw/conversions";

type Props = {
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
};

const GooglePostbackControl = ({
  checked,
  disabled = false,
  onCheckedChange,
}: Props) => {
  return (
    <AdAccountPostbackControl
      checked={checked}
      disabled={disabled}
      onCheckedChange={onCheckedChange}
      helperText={
        checked ? (
          <>
            Conversion postback is enabled for Google Ads and is sending data to
            your conversion action:{" "}
            <a
              href={GOOGLE_ADS_CONVERSIONS_URL}
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              {GOOGLE_CONVERSION_ACTION_NAME}
            </a>
          </>
        ) : (
          "When enabled Tracify will create a dedicated Google Ads conversion action for this organisation"
        )
      }
    />
  );
};

export default GooglePostbackControl;
